import {AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {AppEmbed} from "@thoughtspot/visual-embed-sdk";
import {AuthService} from "@app/_services/auth.service";
import {ThoughtspotService} from "@app/_services/thoughtspot.service";
import {IdentityUser} from "@app/_models/identityUser";
import {Subscription} from "rxjs";

@Component({
    selector: "app-ts-full-app-embed",
    templateUrl: "./full-app.component.html",
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./full-app.component.scss"]
})
export class FullAppComponent implements OnInit, OnDestroy, AfterViewInit {
    @ViewChild("tsEmbed") tsEmbed!: ElementRef;
    private userSubscription: Subscription;
    user: IdentityUser | null = null;

    constructor(private authService: AuthService, private thoughtspotService: ThoughtspotService) {
        this.userSubscription = this.authService.user().subscribe((user: IdentityUser | null) => this.user = user);
    }

    ngOnInit(): void {
        this.thoughtspotService.initEmbedSDK();
    }

    ngAfterViewInit() {
        this.renderEmbed();
    }

    ngOnDestroy() {
        this.userSubscription.unsubscribe();
    }

    private renderEmbed() {
        const tsDiv = this.tsEmbed.nativeElement;
        const tsEmbed = new AppEmbed(tsDiv, {
            frameParams: {
                width: "100%",
                height: "100%"
            }
        });

        tsEmbed.render().then();
    }
}
